/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szma202aResponseCtrDiscntsMst {
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode?: string;
    /**
     * 割引指定区分１：数字
     */
    discntSiteiDiv1?: string;
    /**
     * 割引指定区分２：数字
     */
    discntSiteiDiv2?: string;
    /**
     * 割引指定区分３：数字
     */
    discntSiteiDiv3?: string;
    /**
     * 割引指定区分４：数字
     */
    discntSiteiDiv4?: string;
    /**
     * 割引指定区分５：数字
     */
    discntSiteiDiv5?: string;
    /**
     * 割引正式名称：全角
     */
    discntAname?: string;
    /**
     * 割引略称名称：全角
     */
    discntRyaku?: string;
    /**
     * 割引範囲開始値
     */
    discntRangeStart?: number;
    /**
     * 割引範囲終了値
     */
    discntRangeEnd?: number;
    /**
     * 割引タイプコード：英数字<br>　コード変換マスターテーブル.画面項目ID「C011553」のユーザコードを設定
     */
    discntType?: string;
    /**
     * 割引タイプコード名称：全半角混在
     */
    discntTypeAname?: string;
    /**
     * 割引対象料金下限額
     */
    discntTargetMin?: number;
    /**
     * 契約割引上限金額
     */
    discntMaxValue?: number;
    /**
     * 契約割引パーセント
     */
    discntRate?: number;
}

